import { Dialog, Icon } from "armstrong-react";
import React from "react";
import { CircleDots } from "../../../../../core/atoms";
import { ClippedVideoPlaceholder } from "../../../../components/video/clippedVideoPlaceholder";
import { EmbeddedVideo } from "../../../../components/video/embeddedVideo";

import "./aboutVideo.scss";

export const AboutVideo = () => {
  const [videoModalVisible, setVideoModalVisible] = React.useState<boolean>(false);

  return (
    <div className="about-video width-wrapper">
      <div className="column is-8-tablet is-offset-4-tablet is-9-desktop is-offset-3-desktop">
        <Dialog title="What makes us different?"
          className="home-intro-embedded-video"
          width="100%"
          onClose={() => setVideoModalVisible(false)}
          isOpen={videoModalVisible}>
          <div className="close-button" onClick={() => setVideoModalVisible(false)}><span>x</span></div>
          <EmbeddedVideo videoId="317646737" />
        </Dialog>
        <div className="about-video__wrapper">
          <div className="about-video__text">
            <p>Watch our video to get an idea of who we are, what we do, and how we make your perfect tailor-made holiday</p>
            <button
              className="primary-button heading--4"
              title="Play video"
              onClick={() => setVideoModalVisible(true)}
            >
              Play video <Icon icon={Icon.Icomoon.triangle} className="about-video__button-icon" />
            </button>
          </div>
          <div className="about-video__video">
            <ClippedVideoPlaceholder
              imageUrl="https://resources.travellocal.com/homepage/video-thumbnail-mariana.jpg"
              onClick={() => setVideoModalVisible(true)}
              alt="Mariana, a local expert - Costa Rica"
            />
          </div>
        </div>
      </div>      
    </div>

  );
}
